import { explainSocialUrl, type ExternalUrlRejection } from '@dukanti/shared';
import type { TranslationKey } from '@dukanti/shared/i18n';

/** The message shows after this much idle time, so the first characters typed raise nothing. */
export const EXTERNAL_URL_IDLE_MS = 1000;

const REASON_KEYS: Readonly<Record<ExternalUrlRejection, TranslationKey>> = {
  https: 'admin.destination.externalHttpsRequired',
  host: 'admin.destination.externalHostUnsupported',
  length: 'admin.destination.externalTooLong',
  syntax: 'admin.destination.externalInvalid',
};

/** Admin locale key of why a URL is refused, or null when it is allowed. */
export function externalUrlIssueKey(url: string): TranslationKey | null {
  if (url === '') return 'admin.destination.externalRequired';
  const explained = explainSocialUrl(url);
  return explained.ok ? null : REASON_KEYS[explained.reason];
}
